module.exports = __webpack_public_path__ + "194e1bfac871d8fa4fc27d8952deb9ca.pdf";